import { moveItemInArray } from '@angular/cdk/drag-drop';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { lastValueFrom, Subscription } from 'rxjs';
import { DocumentActor } from 'src/app/models/actors';
import { BuilderRequest } from 'src/app/models/requests';
import { User } from 'src/app/models/user';
import { ActorApiClient } from 'src/app/services/api-clients/actor.api-client';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { ToastService } from 'src/app/services/toast.service';
import { PersonDialogComponent } from '../person-dialog/person-dialog.component';
import { LoggingService } from 'src/app/services/logging.service';
import { Placeholder, WorkflowStep1Placeholder, WorkflowStep2, WorkflowStep2Placeholder, WorkflowStep3Placeholder } from 'src/app/models/workflow';
import { PersonApiClient } from 'src/app/services/api-clients/person.api-client';
import { ActorActionEnum, Is_ANY_Download_Action } from 'src/app/constants/actor-action.enum';
import { IdentityProviderConstants } from 'src/app/constants/identity-provider.constants';
import { RequestBuilderService } from '../request-builder.service';

@Component({
  selector: 'app-add-persons',
  templateUrl: './addpersons.component.html'
})
export class AddPersonsComponent implements OnInit, OnDestroy {

  @Input('organisationSettings') organisationSettings: any;
  @Input('currentUserAdded') currentUserAdded!: boolean;
  @Input('requestId') requestId: string | null = this.route.snapshot.paramMap.get('requestId');
  @Input('showMessage') showMessage!: boolean;
  @Output("complete") complete: boolean;
  @Output('currentStep') step = new EventEmitter<string>();
  @Output('currentUserAddedChange') currentUserAddedChange = new EventEmitter<boolean>();
  @Output() removePlaceholderActions: EventEmitter<number> = new EventEmitter<number>();

  request!: BuilderRequest;
  workflowData?: WorkflowStep2;
  step3placeholders: WorkflowStep3Placeholder[] = [];
  step1placeholders: WorkflowStep1Placeholder[] = [];
  secureFileSending: boolean = false;
  defaultDeadlineDaysFromNow?: number;
  translations: any = <any>{};
  updateTimer: number = Date.now();
  // showAddMyself: boolean = false;
  updateId!: string;
  orderPersons: DocumentActor[] = [];
  newPersonOrder: any = [];
  modalSubscription: Subscription = new Subscription();

  usersubscription: Subscription;
  requestSubscription: Subscription;
  workflowSubscription: Subscription;
  user!: User;

  constructor(private translateService: TranslateService, private modalService: NgbModal,
    private authenticationService: AuthenticationService, private actorService: ActorApiClient, private personService: PersonApiClient, private toastService: ToastService,
    private route: ActivatedRoute, private loggingService: LoggingService, private requestBuilderService: RequestBuilderService) {
    this.usersubscription = this.authenticationService.currentUser.subscribe((data) => {
      this.user = data;
    });
    this.getTranslations();
    translateService.onLangChange.subscribe(() => {
      this.getTranslations();
    });
    this.requestSubscription = this.requestBuilderService.request$.subscribe((request) => {
      this.request = request;
    });
    this.workflowSubscription = this.requestBuilderService.workflowData$.subscribe((workflow) => {
      this.workflowData = workflow.step2;
      this.step3placeholders = workflow.step3?.placeholders;
      this.step1placeholders = workflow.step1?.placeholders;
      this.secureFileSending = workflow?.step3?.allowedActions && workflow?.step3?.allowedActions?.length === 1 && Is_ANY_Download_Action(workflow?.step3?.allowedActions![0].type)
      this.defaultDeadlineDaysFromNow = workflow?.step3?.defaultDeadlineDaysFromNow;
    });
    this.complete = this.request && this.request.dossierPersons ? this.request.dossierPersons.length > 0 : false;
  }

  getTranslations() {
    this.translateService.get([
      'Toasts.RequestsDownloadError',
      'Toasts.RequestsResendOne',
      'Toasts.RequestsResendMultiple',
      'Toasts.DuplicatePersonError',
      'Toasts.AddPersonError',
      'Toasts.UpdatePersonError',
      'Toasts.RemovePersonError',
      'Toasts.Error'
    ]).subscribe(translation => {
      this.translations.toastsRequestsDownloadError = translation['Toasts.RequestsDownloadError'];
      this.translations.toastsRequestsResendOne = translation['Toasts.RequestsResendOne'];
      this.translations.toastsRequestsResendMultiple = translation['Toasts.RequestsResendMultiple'];
      this.translations.toastsDuplicatePersonError = translation['Toasts.DuplicatePersonError'];
      this.translations.toastsAddPersonError = translation['Toasts.AddPersonError'];
      this.translations.toastsUpdatePersonError = translation['Toasts.UpdatePersonError'];
      this.translations.toastsRemovePersonError = translation['Toasts.RemovePersonError'];
      this.translations.error = translation['Toasts.Error'];
    });
  }

  ngOnInit(): void {
    if (this.workflowData && !this.workflowData.placeholders && this.workflowData.addCurrentUser && this.showAddMyself() && !this.currentUserAdded) {
      this.addMyself();
      this.currentUserAddedChange.emit(true);
    }
    if (this.workflowData && this.workflowData.placeholders) {
      this.workflowData.placeholders.forEach((placeholder: WorkflowStep2Placeholder) => {
        if (placeholder.currentUser && this.showAddMyself() && !this.currentUserAdded) this.addMyself(placeholder.placeholderId);
      }
      );
    }
  }

  ngOnDestroy(): void {
    this.modalSubscription.unsubscribe();
    this.usersubscription.unsubscribe();
    this.requestSubscription.unsubscribe();
  }

  setUrl() {
    let url = new URL(window.location.href);
    url.pathname += "/" + this.requestId;
    let new_url = url.toString();
    window.history.pushState({}, '', new_url);
  }

  async removeExistingActionsForPlaceholder(placeholderId: number) {
    let actionPlaceholdersForPerson = this.step3placeholders?.filter(placeholder => placeholder.defaultPersonPlaceholderId == placeholderId);
    if (!actionPlaceholdersForPerson)
      return;

    for (const actionPlaceholder of actionPlaceholdersForPerson) {
      let existingActionIndex = this.request.actors.findIndex(actor => actor.workflowPlaceholderId == actionPlaceholder.placeholderId);
      if (existingActionIndex > -1) {
        try {
          let existingActor = this.request.actors[existingActionIndex];
          let removeAction = await this.actorService.Delete(this.request.id!, existingActor.id);
          await lastValueFrom(removeAction);
        } catch (error: any) {
          this.loggingService.logException(error);
        }
      }
    }
  }

  async addPerson(placeholderId?: number) {
    if (!this.request.dossierPersons) this.request.dossierPersons = [];
    let ngbModalOptions: NgbModalOptions = {
      centered: true,
      size: 'md',
      backdrop: 'static'
    };
    let placeholder: Placeholder = new Placeholder;
    if (this.workflowData && this.workflowData.placeholders && placeholderId) placeholder = this.workflowData.placeholders.find(s => s.placeholderId === placeholderId)!;
    const modalRef = this.modalService.open(PersonDialogComponent, ngbModalOptions);
    modalRef.componentInstance.showMessage = this.showMessage;
    modalRef.componentInstance.organisationSettings = this.organisationSettings;
    modalRef.componentInstance.allowAddAnother = !this.workflowData || ((this.workflowData.maxPersonAmount ? this.workflowData.maxPersonAmount > (this.request.dossierPersons?.length ?? 0) + 1 : true) && (!this.workflowData.placeholders || this.workflowData.placeholders.length === 0 || this.workflowData.placeholders.find(p => p.placeholderId === placeholderId)?.allowMultiple));
    this.modalSubscription = modalRef.closed.subscribe(
      (value: any) => {
        (async (value: any) => {
          if (!value) return;

          if (value.person.prefix == null) value.person.prefix = '';
          value.person.workflowPlaceholderId = placeholderId;
          value.person.ordinal = 0;
          if (placeholderId && this.request.dossierPersons.filter(s => (s.workflowPlaceholderId != null ? s.workflowPlaceholderId : 1) <= placeholderId).length > 0 && placeholderId != (this.workflowData?.placeholders && this.workflowData.placeholders.length > 0 ? this.workflowData.placeholders[0].placeholderId : 1)) {
            value.person.ordinal = this.request.dossierPersons.filter(s => (s.workflowPlaceholderId != null ? s.workflowPlaceholderId : 1) <= placeholderId).length > 0 ? Math.max(...this.request.dossierPersons.filter(s => (s.workflowPlaceholderId != null ? s.workflowPlaceholderId : 1) <= placeholderId).map(a => a.ordinal)) + 1 : this.request.dossierPersons.length;
          } else if (!placeholderId) {
            value.person.ordinal = this.request.dossierPersons.length;
          }

          if (this.request.dossierPersons.findIndex(s => s.email === value.person.email && s.mobile === value.person.mobile) > -1) {
            this.toastService.showError("" + this.translations.error + "", "" + this.translations.toastsDuplicatePersonError + "");
            return;
          } else {
            if (placeholderId && this.request?.dossierPersons?.filter((s: DocumentActor) => s.workflowPlaceholderId! > placeholderId).length > 0) {
              value.workflowPlaceholderId = placeholderId !== undefined ? placeholderId : null;
              this.orderPersons = this.request.dossierPersons;
              this.orderPersons?.filter((s: DocumentActor) => s.workflowPlaceholderId! > placeholderId).forEach((act: DocumentActor, i: number) => {
                act.ordinal = act.ordinal + 1;
              });
              (await this.personService.changeOrder(this.request.id, this.orderPersons)).subscribe({
                error: (error: HttpErrorResponse) => { },
                next: () => {
                  this.request.dossierPersons.push(value.person as DocumentActor);
                  this.PersonUpdated(value.person);
                  this.requestBuilderService.updatePersonProgress();
                }
              });
            } else {
              this.request.dossierPersons.push(value.person as DocumentActor);
              this.PersonUpdated(value.person);
              this.requestBuilderService.updatePersonProgress();
            }
          }

          if (placeholder && !placeholder.allowMultiple) {
            let placeholderStep3: Placeholder[] | undefined = this.step3placeholders?.filter(s => s.defaultPersonPlaceholderId === placeholderId);
            if (placeholderStep3 && placeholderStep3.length > 0) {
              placeholderStep3.forEach(ph => {
                if (this.request.actors.findIndex(d => d.workflowPlaceholderId === ph.placeholderId && d.dossierPersonId !== value.person.dossierPersonId) > -1) {
                  this.removePlaceholderActions.emit(ph.placeholderId);
                }

              });
            }
          }

          if (value.addAnother) {
            this.addPerson(placeholderId).catch((error) => this.loggingService.logException(error));
          }
        })(value);
      }
    );
  }

  useExistingDossierPerson(placeholderId: number, newUserEmail: string, newUserPhoneNumber: string) {
    let existingDossierPerson = this.request.dossierPersons?.find(person => person.email == newUserEmail && person.mobile == newUserPhoneNumber);
    if (existingDossierPerson != undefined) {
      this.workflowData?.placeholders?.splice(this.workflowData?.placeholders?.findIndex(placeholder => placeholder.placeholderId == placeholderId), 1);
      let actorPlaceholders = this.step3placeholders?.filter(placeholder => placeholder.defaultPersonPlaceholderId == placeholderId);
      actorPlaceholders?.forEach(placeholder => {
        placeholder.defaultPersonPlaceholderId = existingDossierPerson!.workflowPlaceholderId!;
      });
      this.requestBuilderService.updatePersonProgress();
      return true;
    }

    return false;
  }

  async addMyself(placeholderId?: number) {
    if (placeholderId) {
      await this.removeExistingActionsForPlaceholder(placeholderId);
      if (this.useExistingDossierPerson(placeholderId, this.user.email, this.user.phoneNumber))
        return;
    }

    let myself = new DocumentActor();
    myself.firstname = this.user.firstname;
    myself.prefix = this.user.prefix ?? '';
    myself.lastname = this.user.lastname;
    myself.email = this.user.email;
    myself.mobile = this.user.phoneNumber;
    myself.language = localStorage.getItem('language')?.toUpperCase() ?? 'NL';
    myself.validateRealIdentity = false;
    myself.identityProvider = this.workflowData?.allowedIdentityProviders && this.workflowData.allowedIdentityProviders.length > 0 ? this.workflowData.allowedIdentityProviders[0] : IdentityProviderConstants.Default;
    myself.workflowPlaceholderId = placeholderId ?? null;
    myself.ordinal = 0;
    if (!this.request.dossierPersons || this.request.dossierPersons.length === 0) this.request.dossierPersons = [];
    if (placeholderId && this.request?.dossierPersons?.length > 0 && placeholderId != (this.workflowData?.placeholders && this.workflowData.placeholders.length > 0 ? this.workflowData.placeholders[0].placeholderId : 1)) {
      myself.ordinal = this.request.dossierPersons.filter(s => (s.workflowPlaceholderId != null ? s.workflowPlaceholderId : 1) <= placeholderId).length > 0 ? Math.max(...this.request.dossierPersons.filter(s => (s.workflowPlaceholderId != null ? s.workflowPlaceholderId : 1) <= placeholderId).map(a => a.ordinal)) + 1 : this.request.dossierPersons.length;
    } else if (!placeholderId) {
      myself.ordinal = this.request.dossierPersons.length;
    }
    if (!this.request.dossierPersons) this.request.dossierPersons = [];
    if (placeholderId && this.request?.dossierPersons?.filter((s: DocumentActor) => s.workflowPlaceholderId! > placeholderId).length > 0) {
      this.orderPersons = this.request.dossierPersons;
      this.orderPersons?.filter((s: DocumentActor) => s.workflowPlaceholderId! > placeholderId).forEach((act: DocumentActor, i: number) => {
        act.ordinal = act.ordinal + 1;
      });
      (await this.personService.changeOrder(this.request.id, this.orderPersons)).subscribe({
        error: (error: HttpErrorResponse) => { },
        next: () => {
          if (this.request.dossierPersons.filter(s => s.email === myself.email && s.mobile === myself.mobile).length === 0) this.request.dossierPersons.push(myself);
          this.addPersonCall(myself);
          this.requestBuilderService.updatePersonProgress();
        }
      });
    } else {
      if (this.request.dossierPersons.filter(s => s.email === myself.email && s.mobile === myself.mobile).length === 0) this.request.dossierPersons.push(myself);
      await this.addPersonCall(myself);
      this.requestBuilderService.updatePersonProgress();
    }
  }
  PersonUpdated(person: any) {
    if (person.firstname && person.lastname && person.email && person.mobile)
      this.triggerUpdatePersonTimer(person);

    this.triggerUpdatePersonProgress();

    this.requestBuilderService.updateRequest(this.request);
  }

  triggerUpdatePersonProgress() {
    this.requestBuilderService.updatePersonProgress();
  }

  private triggerUpdatePersonTimer(person: DocumentActor) {
    this.updateId = person.dossierPersonId;
    if (person.dossierPersonId === null || person.dossierPersonId === undefined || person.dossierPersonId === "") {
      this.addPersonCall(person).catch((error) => this.loggingService.logException(error));
    } else {
      this.UpdatePerson(person).catch((error) => this.loggingService.logException(error));
    }
  }

  private updateDossierPersonsAndActors(dossierPersonId: string, value: any) {
    let dossierPersonIndex = this.request.dossierPersons.findIndex(p => p.dossierPersonId == dossierPersonId);

    if (dossierPersonIndex > -1) {
      this.request.dossierPersons[dossierPersonIndex].firstname = value.firstname;
      this.request.dossierPersons[dossierPersonIndex].prefix = value.prefix;
      this.request.dossierPersons[dossierPersonIndex].lastname = value.lastname;
      this.request.dossierPersons[dossierPersonIndex].email = value.email;
      this.request.dossierPersons[dossierPersonIndex].mobile = value.mobile;
      this.request.dossierPersons[dossierPersonIndex].fullName = value.firstname + " " + value.prefix + " " + value.lastname;
      this.request.dossierPersons[dossierPersonIndex].fullName = this.request.dossierPersons[dossierPersonIndex].fullName.replace("  ", " ");
      this.request.dossierPersons[dossierPersonIndex].language = value.language;
      this.request.dossierPersons[dossierPersonIndex].validateRealIdentity = value.validateRealIdentity;
      this.request.dossierPersons[dossierPersonIndex].identityProvider = value.identityProvider;
      this.request.dossierPersons[dossierPersonIndex].message = value.message;
      this.request.dossierPersons[dossierPersonIndex].ordinal = value.ordinal;
    }

    if (this.request.actors &&
      (this.request.actors.findIndex(a => a.dossierPersonId == dossierPersonId) > -1
        || this.request.actors.findIndex(a => a.email === value.email && a.mobile === value.mobile) > -1)) {
      this.request.actors.forEach(p => {
        if (p.dossierPersonId == dossierPersonId || (p.email === value.email && p.mobile === value.mobile)) {
          p.firstname = value.firstname;
          p.prefix = value.prefix;
          p.lastname = value.lastname;
          p.email = value.email;
          p.mobile = value.mobile;
          p.fullName = value.firstname + " " + value.prefix + " " + value.lastname
          p.fullName = p.fullName.replace("  ", " "),
            p.language = value.language
          p.dossierPersonId = dossierPersonId;
          if (this.secureFileSending && this.defaultDeadlineDaysFromNow) {
            p.action = ActorActionEnum.Download;
            p.documentId = this.request.documentInfo[0].id;
            p.deadline = new Date(new Date().setDate(new Date().getDate() + this.defaultDeadlineDaysFromNow));
          }
        }
      });
    }
  }

  private async addPersonCall(person: DocumentActor) {
    (await this.actorService.addDossierPerson(this.request.id, person)).subscribe({
      error: (error: HttpErrorResponse) => {
        this.toastService.showError("" + this.translations.error + "", "" + this.translations.toastsAddPersonError + "");
        let personIndex = this.request.dossierPersons.findIndex(p => p == person);
        if (personIndex > -1)
          this.request.dossierPersons.splice(personIndex, 1);
      },
      next: (value: any) => {
        person.dossierPersonId = value.dossierPersonId;
        this.updateDossierPersonsAndActors(person.dossierPersonId, value);
      }
    });
  }

  private async UpdatePerson(person: DocumentActor) {
    delete person.action;
    (await this.actorService.updateDossierPerson(this.request.id, person)).subscribe({
      error: (error: HttpErrorResponse) => this.toastService.showError("" + this.translations.error + "", "" + this.translations.toastsUpdatePersonError + ""),
      next: (value: any) => {
        let dossierPersonIndex = this.request.dossierPersons.findIndex(item => item.dossierPersonId === value.id);
        if (dossierPersonIndex > -1) this.request.dossierPersons[dossierPersonIndex] = value;
        this.updateDossierPersonsAndActors(person.dossierPersonId, value);
      }
    });
  }

  async RemovePerson(person: DocumentActor) {
    let actorIndex = this.request.actors.findIndex(item => item.dossierPersonId == person.dossierPersonId);
    if (actorIndex > -1) {
      let actor = this.request.actors[actorIndex];

      let removeEvent = {
        actorId: actor.id,
        dossierPersonId: person.dossierPersonId,
        documentId: actor.documentId
      }
      // await this.RemoveAction(removeEvent);  <--TODO-->
    }
    (await this.actorService.removeDossierPerson(this.request.id!, person)).subscribe({
      error: (error: HttpErrorResponse) => this.toastService.showError("" + this.translations.error + "", "" + this.translations.toastsRemovePersonError + ""),
      next: (value: any) => {
        if (!this.workflowData || !this.workflowData.placeholders || this.workflowData.placeholders.length === 0) {
          for (let dossierPerson of this.request.dossierPersons.filter((dp) => dp.ordinal > person.ordinal)) {
            dossierPerson.ordinal--;
            this.UpdatePerson(dossierPerson).catch(error => this.loggingService.logException(error));
          }
        }
        let dossierPersonIndex = this.request.dossierPersons.findIndex(item => item.dossierPersonId === person.dossierPersonId);
        if (dossierPersonIndex > -1)
          this.request.dossierPersons.splice(dossierPersonIndex, 1);

        this.triggerUpdatePersonProgress();
      }
    });
    this.requestBuilderService.updateRequest(this.request);
    this.triggerUpdatePersonProgress();
  }

  async PersonChangeOrder(event: any) {
    this.orderPersons = this.request.dossierPersons;
    moveItemInArray(this.orderPersons, event.previousIndex, event.currentIndex);
    this.orderPersons.forEach((s: DocumentActor, index: number) => {
      s.ordinal = index;
    })
    this.changeOrderPersons().catch((error) => this.loggingService.logException(error));
  }

  async changeOrderPersons() {
    (await this.personService.changeOrder(this.request.id, this.orderPersons)).subscribe({
      error: (error: HttpErrorResponse) => { },
      next: (value: any) => {
      }
    });
  }

  showAddMyself() {
    if (this.request.dossierPersons && this.request.dossierPersons.findIndex(d => d.email == this.user.email && d.mobile == this.user.phoneNumber) > -1) return false;
    if (!this.workflowData) return true;
    if (this.workflowData && (this.workflowData.allowCurrentUser == undefined || this.workflowData.allowCurrentUser === true)) return true;
    return false;
  }
}